import axios from 'axios';

const apiUrl = process.env.REACT_APP_BACKEND_API_URL;


export const getSales = async (teamName: string, yearMonth: string): Promise<string> => {
  const postData = { team_name: teamName, year_month: yearMonth };
  const response = await axios.post(`${apiUrl}/maintenance/getTotalPurchaseByTeamAndDate/`, postData, { withCredentials: true });
  return response.data.total_quantity;
}